var render, staticRenderFns
import script from "./lemon-message-video.vue?vue&type=script&lang=js"
export * from "./lemon-message-video.vue?vue&type=script&lang=js"
import style0 from "./lemon-message-video.vue?vue&type=style&index=0&id=0257b4dc&prod&scoped=true&lang=css"
import style1 from "./lemon-message-video.vue?vue&type=style&index=1&id=0257b4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0257b4dc",
  null
  
)

export default component.exports